// extracted by mini-css-extract-plugin
export var wrap = "styles-module--wrap--2qkEz";
export var jsAnimInit = "styles-module--jsAnimInit--1Ty9m";
export var links = "styles-module--links--1dJ1U";